import { render, staticRenderFns } from "./ExclamationTriangleIcon.vue?vue&type=template&id=142f15c9&scoped=true"
import script from "./ExclamationTriangleIcon.vue?vue&type=script&lang=js"
export * from "./ExclamationTriangleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f15c9",
  null
  
)

export default component.exports